import React, { useEffect, useState } from 'react';
import { GridContainer,Grid } from '../../../shared/grid';
import { Formik, Form } from 'formik';
import { Autocomplete, InputAdornment, TextField, Typography } from '@mui/material';
import { ValidCharacters, errorResponse, validateCharacters } from '../../../store/common';
import Button from '@mui/material/Button';
import '../FieldSample.scss';
import * as Yup from 'yup';
import moment from 'moment-timezone';
import { useStoreContext } from '../../../store/context';
import { DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAddAlert } from 'src/store/actions';
import { getCategoryByType, getCodes } from 'src/apis/getFuelSampleCalls';
import { newSampleFromChildCallback } from '../SampleSubSample/FieldSampleChild';
import { createUpdateSample } from 'src/apis/mutationsFuelSample';
import Box from "@mui/material/Box";
import {
  usePickerLayout,
  PickersLayoutRoot,
  pickersLayoutClasses,
  PickersLayoutContentWrapper,
} from "@mui/x-date-pickers/PickersLayout";
import { alertMessages } from 'src/constants';

export const validationSchema = Yup.object().shape(
    {
        sampleType: Yup.string() 
          .required('Type is Required'),
        sampleCategory: Yup.string().nullable()
          .required('Category is Required'),
        sampleSubCategory: Yup.string().nullable(),
        sampleMethod: Yup.string().nullable(),
        sampleDate: Yup.string().nullable()
          .required('Sample Date & Time are Required'),
    }
);

type SampleProps ={
  setOpen: any,
  open: boolean,
  editSample?: any,
  isNew?: boolean,
  id: string,
  setAddSampleCalled:any,
  sampleCallBack:any
}

const CHILD_WIDTH = "3.6rem";
export function HrCustomLayout(props) {
  const { toolbar, tabs, content, actionBar } = usePickerLayout(props);
  return (
    <PickersLayoutRoot className={pickersLayoutClasses.root} ownerState={props}>
      {toolbar}
      <Box
        sx={{
          gridColumn: 2,
          display: props.wrapperVariant === "desktop" ? "flex" : "none",
          justifyContent: "end",
          textAlign: "center",
        }}
      >
        <Typography component='div' sx={{ width: CHILD_WIDTH }}> <Box fontWeight='fontWeightMedium' display='inline'>HR</Box></Typography>
      </Box>
      <PickersLayoutContentWrapper
        sx={{
          ".MuiMultiSectionDigitalClock-root": {
            ul: {
              width: CHILD_WIDTH,
              boxSizing: "border-box",
            },
          },
        }}
      >
        {tabs}
        {content}
      </PickersLayoutContentWrapper>
      {actionBar}
    </PickersLayoutRoot>
  );
}

export const Sample: React.FC<SampleProps> = ({setOpen,id, open, editSample, isNew, setAddSampleCalled,sampleCallBack}) =>{
  const [state,setState] = useStoreContext();
  const [token, setToken] = useState<string|null>(null);
  const addAlert = useAddAlert(setState);

  interface FormVals {
    sampleType: string, 
    sampleCategory: string,
    sampleSubCategory: string|null,
    sampleDate: string|null,
    sampleMethod: string|null,
    siteId: string
  }


  const handleSubmit= (values:any)=>{
    (async()=>{
      try{
        const responseFromUpdate:any = await createUpdateSample(null, values, setAddSampleCalled, false, addAlert);
        if(responseFromUpdate){
          sampleCallBack.setSampleRecentlyAdded(responseFromUpdate.data.data.createUpdateSample)
          newSampleFromChildCallback(values, sampleCallBack.setIsChildCalledBack, sampleCallBack.setNewSampleFromChildComponent);
          setOpen(!open);
        }
        else{
          if (responseFromUpdate?.toString()?.includes('duplicate')) {
            errorResponse(responseFromUpdate, addAlert, responseFromUpdate);
          }
          else {
            errorResponse(responseFromUpdate, addAlert, alertMessages.fieldSampleSave);
          }
        }
      }
      catch (error: any) {
        if (error?.toString()?.includes('duplicate')) {
          errorResponse(error, addAlert, error);
        }
        else {
          errorResponse(error, addAlert, alertMessages.fieldSampleSave);
        }
      }
    })()
  }

  let initVals: FormVals = { sampleType: '', sampleCategory: '', sampleSubCategory: null, 
    sampleDate: null, sampleMethod:null, siteId: id
  }
  const [errorDate, setErrorDate] = useState<string|null>(null);
  
  useEffect(()=>{
    /** find access token and set to send to bearer */
    if((state.userTokens && token) || localStorage.getItem('user')) {
      /** If the Token is refreshed this will set the @param token equal to updated value */
      setToken(state.userTokens.accessToken);
    }

  },[state.userTokens, token]);

  if(editSample){
    const sampleEdit: FormVals ={
      sampleType: editSample.fuel_type,
      sampleCategory: editSample.category,
      sampleSubCategory: editSample.sub_category,
      sampleDate: editSample.date,
      sampleMethod: editSample.method,
      siteId: id,

    }
    initVals = sampleEdit;
  }

  const [sampleMethods, setSampleMethods] = useState<any[]>([]);
  const [sampleSubCats, setSampleSubCats] = useState<any[]>([]);
  const [sampleCategories, setSampleCategories] = useState<any[]>([]);
  const [sampleTypes, setSampleTypes] = useState<any[]>([]);
  const [filteredCategories, setFilteredCategories] =useState<any[]>([]);
  const [filteredTypes, setFilteredTypes] =useState<any[]>([]);
  const [methodsNotDeadCat, setMethodsNotDeadCat] = useState<any[]>([])

  useEffect(()=>{
    if(sampleTypes.length<1){
      (async()=>{
        try{
          const requestVars ={
            returnAll: true,
            type: null
          }
          const codeResponse:any = await getCodes(requestVars);
          setSampleTypes(codeResponse.types.sort((a:any,b:any)=>a.code_key.localeCompare(b.code_key)));
          setSampleCategories(codeResponse.cats.sort((a:any,b:any)=>a.code_key.localeCompare(b.code_key)));
          setSampleSubCats(codeResponse.subCats.sort((a:any,b:any)=>a.code_key.localeCompare(b.code_key)));
          const nonDeadMethods = codeResponse.methods?.filter((method:any) => !method.code_key?.includes('Moisture Probe'));
          setMethodsNotDeadCat(nonDeadMethods.sort((a:any,b:any)=>a.code_key.localeCompare(b.code_key)));
          setSampleMethods(codeResponse.methods.sort((a:any,b:any)=>a.code_key.localeCompare(b.code_key)));
        }
        catch(error){
          errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
        } 
      })();
    }
  },[addAlert, token, sampleTypes.length])

  return(
  <GridContainer className="removePadding smooth-scrollbar" style={{height: '80%', maxHeight: '95%', overflowX: 'hidden'}}>
    <Grid row gap="md" className='page-heading'>
      <Grid
        desktop={{col:12}}
        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
          {
            <span className="font-sans-lg text-bold">New Sample</span>
          }
      </Grid>
    </Grid>
    
    <hr style={{width: '100%', marginBottom: 0}}></hr>
    
    <Formik
      initialValues={initVals}
      validateOnBlur={true}
      validateOnChange={true}
      validateOnMount={true}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values:any) => handleSubmit(values) }>
      {({
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        handleBlur,
        isValid,
        setFieldTouched
      }) => { 
        
          const setSampleType=(newValue: string)=>{
            setFieldTouched('sampleType');
            setFieldValue('sampleType', newValue);
          }
          const setSampleCategory=(newValue: string)=>{
            setFieldTouched('sampleCategory');
            setFieldValue('sampleCategory', newValue);
          }
          const setSubCategory=(newValue: string)=>{
            setFieldTouched('sampleSubCategory');
            setFieldValue('sampleSubCategory', newValue);
          }

          const setMethod=(newValue: string)=>{
            setFieldTouched('sampleMethod');
            setFieldValue('sampleMethod', newValue);
          }   
          const handleDateTime = (newValue: any) => {
            setFieldTouched('sampleDate');
            if(newValue){
              setFieldValue('sampleDate', moment.tz(newValue, state.userTimeZone.id[0]).toISOString());
            }
          }
          const functionToGetCategory =async(type: string, cat:any)=>{
            try{
              const responseArray:any = await getCategoryByType(token, addAlert, type, cat);
                if(responseArray){
                    let uniqueCategories = [...new Set(responseArray.map((r:any)=>r.category))];
                    let uniqueTypes = [...new Set(responseArray.map((r:any)=>r.fuel_type))];
                    if(cat!==null){
                      setFilteredTypes(uniqueTypes.sort((a:any, b: any)=>a.localeCompare(b)));
                    }
                    else{
                      if(type!==null){
                        setFieldValue('sampleCategory', uniqueCategories[0]);
                      }
                      setFilteredCategories(uniqueCategories.sort((a:any, b: any)=>a.localeCompare(b)));
                    }
                }
                else{
                  setFilteredCategories([]);
                  setFilteredTypes([])
                }              
            }
            catch(error){
              errorResponse(error, addAlert, alertMessages.siteSampleData);
            } 
          };

          return(
          <Form onSubmit={handleSubmit}>
            <div className="paddingForm" >
              <Grid row desktop={{ col: 7 }}>
                <label htmlFor="sampleCreateType" id='sampleCreateType'>Type *</label>
                <div className='searchAreas' style={{ width: '100%' }}>
                  <i className="fas fa-search" />
                  <Autocomplete
                    freeSolo
                    disabled= {!isNew}
                    onBlur={handleBlur}
                    onChange={(event: any, newValue: any) => {
                      functionToGetCategory(newValue, null);
                      setSampleType(newValue)
                    }}
                    id='sampleCreateType'
                    style={{ width: '100%' }}
                    value={values.sampleType}
                    options={filteredTypes.length>0 && values.sampleCategory? filteredTypes: sampleTypes.map((type) => type.code_key).sort((a:any, b: any)=> a.localeCompare(b))}
                    renderInput={(params) => (
                      <TextField
                        placeholder='Select Type'
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen, ValidCharacters.Comma)}
                        style={{ width: '100%' }}
                        onBlur={handleBlur}
                        error={!!errors.sampleType && !!touched.sampleType}
                        helperText={!!errors.sampleType && !!touched.sampleType ? 'Type is Required' : ''}
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid row desktop={{ col: 7 }}>
                <label htmlFor="sampleCreateCategory" id='sampleCreateCategory'>Category *</label>
                <div className='searchAreas' style={{ width: '100%' }}>
                  <i className="fas fa-search" />
                  <Autocomplete
                    disabled= {!isNew}
                    freeSolo
                    onBlur={handleBlur}
                    onChange={(event: any, newValue: any) => {
                      functionToGetCategory(values.sampleType, newValue)
                      setSampleCategory(newValue);
                    }}
                    style={{ width: '100%' }}
                    value={values.sampleCategory}
                    id='sampleCreateCategory'
                    options={filteredCategories.length>0 && values.sampleType? (filteredCategories):sampleCategories.map((type) => type.code_key).sort((a:any, b: any)=> a.localeCompare(b))}
                    renderInput={(params) => (
                      <TextField
                        placeholder='Select Category'
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                        style={{ width: '100%' }}
                        onBlur={handleBlur}
                        error={!!errors.sampleCategory && !!touched.sampleCategory}
                        helperText={!!errors.sampleCategory && !!touched.sampleCategory ? 'Category is Required' : ''}
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid row desktop={{ col: 7 }}>
                <label htmlFor="sampleSubCategory" id='sampleSubCategory'>Sub-Category</label>
                <div className='searchAreas' style={{ width: '100%' }}>
                <i className="fas fa-search" />
                  <Autocomplete
                    freeSolo
                    disabled= {!isNew}
                    onBlur={handleBlur}
                    onChange={(event: any, newValue: any) => {
                        setSubCategory(newValue);
                    }}
                    style={{ width: '100%' }}
                    id='sampleSubCategory'
                    value={values.sampleSubCategory}
                    options={sampleSubCats.map((sub) => sub.code_key)}
                    renderInput={(params) => (
                      <TextField
                        placeholder='Select Sub-Category'
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                        style={{ width: '100%' }}
                        onBlur={handleBlur}
                        error={!!errors.sampleSubCategory && !!touched.sampleSubCategory}
                        helperText={!!errors.sampleSubCategory && !!touched.sampleSubCategory ? errors.sampleSubCategory : ''}
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid row gap="md">
                <Grid desktop={{col:7}}>
                  <label htmlFor="SampleCreateDateTime" id="SampleCreateDateTime">Sample Date & Time *</label>
                  <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
                    <DateTimePicker
                      disableFuture
                      views={['year', 'month','day', 'hours']}
                      format="MM/DD/YYYY HH:00"
                      className='width100'
                      ampm={false}
                      value={values.sampleDate? moment.tz(values.sampleDate, state.userTimeZone.id[0]):null}
                      timezone={state.userTimeZone.id[0]}
                      onChange={(newValue)=>{handleDateTime(newValue)}}
                      slots={{
                        layout: HrCustomLayout,
                        
                       }}
                      slotProps={{
                        textField: {
                          error: errorDate || ( touched.sampleDate && errors.sampleDate)? true:false,
                          helperText: errorDate || ( touched.sampleDate && errors.sampleDate),
                          placeholder: "Select Date & Time",
                          id: "SampleCreateDateTime",
                          InputProps:{
                            startAdornment:(
                              <InputAdornment position='start' style={{position: 'absolute', right:0, marginRight: '3rem'}}>{`${state.userTimeZone.code} (${state.userTimeZone.offset})`}</InputAdornment>
                            )
                          }
                        },
                      }}
                        
                      onError={(reason)=>{
                        if(reason===null){
                            setErrorDate(null)
                        }
                        else if(reason === 'disableFuture'){
                          setErrorDate('Date & Time are in the Future');
                        }
                        else if(reason ==='invalidDate'){
                          if(touched.sampleDate){
                            setErrorDate('Invalid Date');

                          }
                        }
                        else{
                            setErrorDate('An Error on Date & Time')
                        }            
                    }}
                    /> 
                  </LocalizationProvider>
                </Grid>

              </Grid>
              <Grid row desktop={{ col: 7 }}>
                <label htmlFor="samplecreateMethod" id='samplecreateMethod'>Method</label>
                <div className='searchAreas' style={{ width: '100%' }}>
                <i className="fas fa-search" />
                  <Autocomplete
                    freeSolo
                    disabled= {!isNew}
                    onBlur={handleBlur}
                    onChange={(event: any, newValue: any) => {
                        setMethod(newValue);
                    }}
                    id='samplecreateMethod'
                    style={{ width: '100%', paddingBottom: '15%' }}
                    value={values.sampleMethod}
                    options={values && values.sampleCategory && values.sampleCategory?.includes('Dead')? 
                      sampleMethods.map((method) => method.code_key): methodsNotDeadCat.map((method)=>method.code_key)}
                    renderInput={(params) => (
                      <TextField
                        placeholder='Select Method'
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                        style={{ width: '100%' }}
                        onBlur={handleBlur}
                        error={!!errors.sampleMethod && !!touched.sampleMethod}
                        helperText={!!errors.sampleMethod && !!touched.sampleMethod ? errors.sampleMethod : ''}
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />
                    )}
                  />
                </div>
              </Grid>
            </div>

            <Grid row className='modalBottomDiv' style={{zIndex:100}}>
              <Grid desktop={{col:10}} className="modalCancelDiv">
                <Button variant="outlined" style={{backgroundColor: 'white'}} onClick={()=>{setOpen(!open)}}>
                  Cancel
                </Button>
              </Grid> 
              <Grid desktop={{col:2}} className='modalSubmitDiv'>
                <Button variant="contained" type="submit" aria-disabled={!isValid || errorDate? true:false}>
                  New Sample
                </Button>
              </Grid>
            </Grid>
          </Form>
          )
      }}
    </Formik>
  </GridContainer>
  )
}